import axios from "axios";
import {
  GOOGLE_CALENDAR_NOT_AUTHORIZED_ERROR_CODE,
  INACTIVE_USER_ERROR_CODE,
  INACTIVE_TENANT_ERROR_CODE,
} from "./errorCodes";

// Create an instance with base url
const instance = axios.create({
  baseURL:
    process.env.REACT_APP_SERVER_URL == "" ||
    process.env.REACT_APP_SERVER_URL == undefined
      ? process.env.REACT_APP_SERVER_URL_LOCAL
      : process.env.REACT_APP_SERVER_URL,
});

// Request interceptor to add the access token to the request header
instance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle errors
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (!error.response) {
      return Promise.reject(
        new Error(
          "Server not responding. Please check your connection or try again later.",
        ),
      );
    } else if (error.response.status === 401) {
      if (
        error.response.data &&
        error.response.data.error_code ===
          GOOGLE_CALENDAR_NOT_AUTHORIZED_ERROR_CODE
      ) {
        return Promise.reject(error);
      } else if (
        error.response.data &&
        (error.response.data.error_code === INACTIVE_USER_ERROR_CODE ||
          error.response.data.error_code === INACTIVE_TENANT_ERROR_CODE)
      ) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        return Promise.reject(error);
      }
      // The case where refresh token expired and the user needs to be logged out
      if (originalRequest.url == "/users/refresh") {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        return Promise.reject(error);
      }

      // The case where the user is invalidated but they can refresh the access token
      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        return Promise.reject(error);
      }

      try {
        const response = await instance.post("/users/refresh", {
          refresh: refreshToken,
        });
        if (response.status === 200) {
          const { access } = response.data;
          localStorage.setItem("accessToken", access);
          originalRequest.headers["Authorization"] = `Bearer ${access}`;
          return instance(originalRequest);
        } else {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
        }
      } catch (err) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");

        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default instance;
